import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Image } from "react-bootstrap";

const ButtonLink = ({
  linkTo,
  stateData,
  isDisabled,
  buttonName,
  buttonClass,
  buttonColor = "success",
  iconSrc,
  iconClass,
  iconName,
  style
}) => {
  return (
    <Link
      className="text-decoration-none"
      to={!isDisabled ? linkTo : "#"}
      state={stateData}
    >
      <Button
        variant={buttonColor}
        className={buttonClass}
        disabled={isDisabled}
        style={style?.button}
      >
        {iconSrc && (
          <Image
            className={iconClass}
            src={iconSrc}
            alt={iconName}
            style={style?.img}
          />
        )}
        {buttonName}
      </Button>
    </Link>
  );
};

ButtonLink.propTypes = {
  linkTo: PropTypes.string.isRequired,
  stateData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isDisabled: PropTypes.bool,
  buttonName: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonColor: PropTypes.string,
  iconSrc: PropTypes.string,
  iconClass: PropTypes.string,
  iconName: PropTypes.string,
  style: PropTypes.object
};

export default ButtonLink;
